<template>
	<div id="app">
		<Header />

		<Loader v-if="$store.state.loading" />

		<section>
			<transition name="bottomwiper" mode="out-in">
				<router-view />
			</transition>
		</section>
	</div>
</template>

<script>
import Header from './components/Header.vue';
import Loader from './components/Loader.vue';

export default {
	name: 'App',
	components: { Header, Loader },
};
</script>

<style lang="scss">
@import '@/styles/main.scss';

#app {
	box-shadow: 0 0 100px 10px #ddd;
	margin: 0 auto;
	max-width: 500px;
	min-height: 100%;
	overflow-x: hidden;
	padding: 60px 0 2em;
	position: relative;
	text-align: justify;
}
</style>
